export function abbreviateNumber(value: number): string {
  if (value < 1000) {
    return value.toString()
  }

  const suffixes = ['', 'k', 'M', 'B', 'T']
  const suffixIndex = Math.floor(('' + value).length / 3)
  let shortValue = parseFloat((suffixIndex !== 0 ? value / Math.pow(1000, suffixIndex) : value).toPrecision(2))

  if (shortValue % 1 !== 0) {
    shortValue = parseFloat(shortValue.toFixed(1))
  }

  return shortValue + suffixes[suffixIndex]
}

export function isAbbreviatedNumber(value: string): boolean {
  return value.endsWith('k') || value.endsWith('M') || value.endsWith('B') || value.endsWith('T')
}
